/**
 * @author: subhasish.ghosh@zoom.us
 */

import React from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import { Suspense } from "react";
import Home from "@pages/Home";
import ProductCatalogue from "@pages/ProductCatalogue";
import Landing from "@components/Landing";
import {
  actionsHasType,
  isCurrentRoleAdmin,
  isProdEnvironment,
} from "@utils/utils";
import {
  SEARCH_PARAM_DEFAULTS_DOWNLOAD,
  SEARCH_PARAM_DEFAULTS_HOME,
  SEARCH_PARAM_DEFAULTS_PRODUCT_CATALOG,
  SEARCH_PARAM_FILENAME,
  SEARCH_PARAM_PAGE,
  SEARCH_PARAM_PAGE_DOWNLOAD,
  SEARCH_PARAM_PAGE_PRODUCT_CATALOG,
  SEARCH_PARAM_PATH
} from "@utils/constants";
import Download from "@pages/Download";
import SearchParamsManager from "@components/SearchParamsManager";
import flags from "@flags";

const PageWrapper = ({ userActionData, userInfoLoading }) => {
  const [searchParams] = useSearchParams();
  const page = Array.from(searchParams.entries())
    ?.find(([key]) => key.toLowerCase() === SEARCH_PARAM_PAGE)?.[1]
    ?.toLowerCase(); // get query param 'page'

  /* product catalog page */
  if (page === SEARCH_PARAM_PAGE_PRODUCT_CATALOG) {
    // check role and environment before rendering ProductCatalogue
    if (!isProdEnvironment()) {
      return (
        <Suspense fallback={<Landing />}>
          <SearchParamsManager
            searchParamDefaults={SEARCH_PARAM_DEFAULTS_PRODUCT_CATALOG}
          />
          <ProductCatalogue
            userActionData={userActionData}
            userInfoLoading={userInfoLoading}
          />
        </Suspense>
      );
    } else {
      return <Navigate to="/" replace />;
    }
  } else if (
    /* download page */
    page === SEARCH_PARAM_PAGE_DOWNLOAD
  ) {
    const fileName = searchParams.get(SEARCH_PARAM_FILENAME) || "download.csv";
    const path= searchParams.get(SEARCH_PARAM_PATH);
    return (
      <Suspense fallback={<Landing />}>
        <SearchParamsManager
          searchParamDefaults={SEARCH_PARAM_DEFAULTS_DOWNLOAD}
        />
        <Download userActionData={userActionData} fileName={fileName} path={path}/>
      </Suspense>
    );
  }

  /* default to home page */
  return (
    <Suspense fallback={<Landing />}>
      <SearchParamsManager searchParamDefaults={SEARCH_PARAM_DEFAULTS_HOME} />
      <Home userActionData={userActionData} userInfoLoading={userInfoLoading} />
    </Suspense>
  );
};

export default PageWrapper;
